// extracted by mini-css-extract-plugin
module.exports = {"transferPoint":"_3CwXPF","startPoint":"_3-FTGD","endPoint":"_9swsbQ","tooltip":"_2Av0pU","tooltipText":"_2MKdfS"};